// extracted by mini-css-extract-plugin
export default {"body":"BodyJson_body__IbjtQ","childStyle":"BodyJson_childStyle__Bvl1O"};